// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const tin: CountryValidator<"AM"> = createValidator(
  "am.tin",
  4,
);

export default tin;
export const compact = tin.compact;
export const format = tin.format;
export const validate = tin.validate;
export const generate = (): string =>
  tin.generate?.() ??
  (() => {
    throw new Error(
      "Validator am.tin cannot generate values",
    );
  })();
